// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useLoader } from '../../../../context/LoaderProvider.jsx';
// import {
//     getAllCateringSettlementsAPI,
//     approveSettlementAPI,
//     generateSettlementRangeAPI,
// } from "../../../Servicefile/CateringSettlementService.jsx";
// const CateringSettelment = () => {
//     const [searchTerm, setSearchTerm] = useState("");
//     const [year, setYear] = useState("");
//     const [month, setMonth] = useState("");
//     const [selectedDate, setSelectedDate] = useState("");
//     const [invoiceData, setInvoiceData] = useState([]);
//     const { showLoader, hideLoader } = useLoader();
//     const [settlements, setSettlements] = useState([]);
//     const [filteredSettlements, setFilteredSettlements] = useState([]);
//     const [error, setError] = useState(null);
//     const [fromDate, setFromDate] = useState("");
//     const [toDate, setToDate] = useState("");


//     // ✅ Function to approve settlement
//     const handleApprove = async (
//         settlementId
//     ) => {
//         try {
//             await approveSettlementAPI(
//                 settlementId
//             );

//             alert(
//                 "✅ Settlement approved successfully!"
//             );

//             // refresh data if needed
//             // fetchSettlements();

//         } catch (error) {
//             console.error(
//                 "❌ Error approving settlement:",
//                 error
//             );

//             let errorMsg =
//                 "❌ Failed to approve settlement.";

//             if (error.response) {
//                 errorMsg +=
//                     `\nStatus: ${error.response.status}\nMessage: ${error.response.data
//                         ?.message ||
//                     "Unknown server error"
//                     }`;

//             } else if (
//                 error.request
//             ) {
//                 errorMsg +=
//                     "\nNo response received from server.";

//             } else {
//                 errorMsg +=
//                     `\nError: ${error.message}`;
//             }

//             alert(errorMsg);
//         }
//     };

//     const handleSend = async () => {
//         if (
//             !fromDate ||
//             !toDate
//         ) {
//             alert(
//                 "⚠️ Please select both From and To dates"
//             );

//             return;
//         }

//         try {
//             await generateSettlementRangeAPI(
//                 fromDate,
//                 toDate
//             );

//             alert(
//                 "✅ Data generated successfully!"
//             );

//         } catch (error) {
//             console.error(
//                 "❌ Error generating range:",
//                 error
//             );

//             alert(
//                 "❌ Failed to generate data. Check console for details."
//             );
//         }
//     };



//     // ✅ Fetch Settlements from API with Token
//     // ✅ Fetch Settlements from API with Token
//     useEffect(() => {
//         const fetchSettlements =
//             async () => {
//                 try {
//                     showLoader();

//                     const data =
//                         await getAllCateringSettlementsAPI();

//                     setSettlements(
//                         data
//                     );

//                     setFilteredSettlements(
//                         data
//                     );

//                 } catch (error) {
//                     console.error(
//                         "❌ Error fetching settlements:",
//                         error
//                     );

//                     setError(
//                         "Error fetching settlements. See console."
//                     );

//                 } finally {
//                     hideLoader();
//                 }
//             };

//         fetchSettlements();

//     }, []);


//     useEffect(() => {
//         let filtered = [...settlements];

//         if (searchTerm) {
//             filtered = filtered.filter((item) =>
//                 item.vendorId.toString().includes(searchTerm)
//             );
//         }

//         if (year) {
//             filtered = filtered.filter(
//                 (item) => new Date(item.settlementDate).getFullYear() === Number(year)
//             );
//         }

//         if (month) {
//             filtered = filtered.filter(
//                 (item) => new Date(item.settlementDate).getMonth() === Number(month)
//             );
//         }

//         if (selectedDate) {
//             filtered = filtered.filter(
//                 (item) => new Date(item.settlementDate).getDate() === Number(selectedDate)
//             );
//         }

//         setFilteredSettlements(filtered);
//     }, [searchTerm, year, month, selectedDate, settlements]);




//     // ✅ Handle year/month/day dropdown
//     const currentYear = new Date().getFullYear();
//     const years = Array.from({ length: currentYear - 2024 + 1 }, (_, i) => 2024 + i);
//     const monthsLabel = [
//         "January", "February", "March", "April", "May", "June",
//         "July", "August", "September", "October", "November", "December"
//     ];
//     const [daysInMonth, setDaysInMonth] = useState([]);

//     useEffect(() => {
//         const y = year ? Number(year) : currentYear;
//         const m = month !== "" ? Number(month) : new Date().getMonth();
//         const days = new Date(y, m + 1, 0).getDate();
//         setDaysInMonth(Array.from({ length: days }, (_, i) => i + 1));
//         if (selectedDate && (selectedDate < 1 || selectedDate > days)) {
//             setSelectedDate("");
//         }
//     }, [year, month, selectedDate]);



//     // ✅ Export CSV
//     const handleExport = () => {
//         // Headers for CSV (match table columns)
//         const headers = [
//             "Vendor ID",
//             "Total Cgst",
//             "Grand Total",
//             "Total Sales",
//             "Service Charges",
//             "To Settle",
//             "Admin Acc",
//             "Vendor Name",
//             "Vendor Acc",
//             "IFSC",
//             "Settlement Date",
//             "Payment Status"
//         ];

//         // Rows of CSV
//         const rows = filteredSettlements.map((it) => [
//             it.vendorId,
//             it.totalCgst,
//             it.totalGrandTotal,
//             it.totalAmountBeforeTds,
//             it.tdsAmount,
//             it.amountAfterTds,
//             it.superadminAccNo,
//             it.holderName,
//             it.accountNumber,
//             it.ifscCode,
//             it.settlementDate,
//             it.paymentStatus === "SUCCESS" ? "Approved" : "Pending" // replace action button with status
//         ]);

//         // Convert to CSV string
//         const csvContent = [headers, ...rows].map((r) => r.join(",")).join("\n");

//         // Download CSV
//         const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//         const link = document.createElement("a");
//         link.href = URL.createObjectURL(blob);
//         link.download = "settlements.csv";
//         link.click();

//         // console.log("✅ CSV exported successfully");
//     };


//     const tableHeaderStyle = {
//         border: "1px solid #ddd",
//         textAlign: "center",
//         fontWeight: "bold",
//         backgroundColor: "rgb(230 109 51)",
//         color: "white",
//         padding: 6,
//     };
//     const tableCellStyle = {
//         border: "1px solid #ddd",
//         textAlign: "center",
//         padding: 6,
//     };

//     return (
//         <div style={{}}>
//             {error && (
//                 <p style={{ color: "red", fontWeight: "bold", marginBottom: 10 }}>
//                     {error}
//                 </p>
//             )}

//             {/* Filters + Export */}
//             <div
//                 style={{
//                     display: "flex",
//                     flexWrap: "wrap",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     marginBottom: 10,
//                     marginTop: 10,
//                     gap: 10,
//                 }}
//             >
//                 <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
//                     <input
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                         placeholder="Search by Vendor ID"
//                         style={{ padding: 6, width: 180, borderRadius: "10px" }}
//                     />

//                     {/* <select value={year} onChange={(e) => setYear(e.target.value)} style={{ padding: 6, borderRadius: "10px" }}>
//                         <option value="">Year</option>
//                         {years.map((y) => <option key={y} value={y}>{y}</option>)}
//                     </select>
//                     <select value={month} onChange={(e) => setMonth(e.target.value)} style={{ padding: 6, borderRadius: "10px" }}>
//                         <option value="">Month</option>
//                         {monthsLabel.map((m, i) => <option key={i} value={i}>{m}</option>)}
//                     </select>
//                     <select value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} style={{ padding: 6, borderRadius: "10px" }}>
//                         <option value="">Date</option>
//                         {daysInMonth.map((d) => <option key={d} value={d}>{d}</option>)}
//                     </select> */}

//                     <input
//                         type="date"
//                         value={fromDate}
//                         onChange={(e) => setFromDate(e.target.value)}
//                         style={{ padding: 6, borderRadius: "10px" }}
//                     />
//                     <span style={{ marginTop: "10px" }}>to</span>
//                     <input
//                         type="date"
//                         value={toDate}
//                         onChange={(e) => setToDate(e.target.value)}
//                         style={{ padding: 6, borderRadius: "10px" }}
//                     />
//                     <button
//                         onClick={handleSend}
//                         style={{
//                             backgroundColor: "#007bff",
//                             color: "white",
//                             border: "none",
//                             borderRadius: "10px",
//                             padding: "6px 15px",
//                             cursor: "pointer",
//                         }}
//                     >
//                         Send
//                     </button>
//                 </div>

//                 <button
//                     onClick={handleExport}
//                     style={{
//                         padding: "6px 12px",
//                         backgroundColor: "rgb(230 109 51)",
//                         color: "#fff",
//                         border: "none",
//                         borderRadius: 4,
//                         cursor: "pointer",
//                     }}
//                 >
//                     Export CSV
//                 </button>
//             </div>

//             {/* Table */}
//             <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                 <thead>
//                     <tr>
//                         <th style={tableHeaderStyle}>Vendor ID</th>
//                         <th style={tableHeaderStyle}>Total Cgst</th>
//                         <th style={tableHeaderStyle}>Grand Total</th>
//                         <th style={tableHeaderStyle}>Total Sales</th>
//                         <th style={tableHeaderStyle}>Service Charges</th>
//                         <th style={tableHeaderStyle}>To Settle</th>
//                         <th style={tableHeaderStyle}>Admin Acc</th>
//                         <th style={tableHeaderStyle}>Vendor Name</th>
//                         <th style={tableHeaderStyle}>Vendor Acc</th>
//                         <th style={tableHeaderStyle}>IFSC</th>

//                         <th style={tableHeaderStyle}>Settlement Date</th>
//                         <th style={tableHeaderStyle}>Action</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {filteredSettlements.length > 0 ? (
//                         filteredSettlements.map((it) => (
//                             <tr key={it.adminId}>
//                                 <td style={tableCellStyle}>{it.vendorId}</td>
//                                 <td style={tableCellStyle}>{it.totalCgst}</td>
//                                 <td style={tableCellStyle}>{it.totalGrandTotal}</td>
//                                 <td style={tableCellStyle}>₹{it.totalAmountBeforeTds}</td>
//                                 <td style={tableCellStyle}>-₹{it.tdsAmount}</td>
//                                 <td style={tableCellStyle}>{it.amountAfterTds}</td>
//                                 <td style={tableCellStyle}>{it.superadminAccNo}</td>
//                                 <td style={tableCellStyle}>{it.holderName}</td>
//                                 <td style={tableCellStyle}>{it.accountNumber}</td>
//                                 <td style={tableCellStyle}>{it.ifscCode}</td>
//                                 <td style={tableCellStyle}>{it.settlementDate}</td>

//                                 {/* ✅ Action Column */}
//                                 <td style={tableCellStyle}>
//                                     {it.paymentStatus === "SUCCESS" ? (
//                                         <button
//                                             disabled
//                                             style={{
//                                                 padding: "6px 12px",
//                                                 backgroundColor: "#9e9e9e", // gray for approved
//                                                 color: "#fff",
//                                                 border: "none",
//                                                 borderRadius: "5px",
//                                                 cursor: "not-allowed",
//                                             }}
//                                         >
//                                             Approved
//                                         </button>
//                                     ) : (
//                                         <button
//                                             onClick={() => handleApprove(it.settlementId)}
//                                             style={{
//                                                 padding: "6px 12px",
//                                                 backgroundColor: "#4caf50",
//                                                 color: "#fff",
//                                                 border: "none",
//                                                 borderRadius: "5px",
//                                                 cursor: "pointer",
//                                             }}
//                                         >
//                                             Approve
//                                         </button>
//                                     )}
//                                 </td>


//                             </tr>
//                         ))
//                     ) : (
//                         <tr>
//                             <td colSpan="12" style={{ textAlign: "center", padding: "10px" }}>
//                                 No settlement data found.
//                             </td>
//                         </tr>
//                     )}
//                 </tbody>
//             </table>


//         </div>
//     );
// };

// export default CateringSettelment;





// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useLoader } from '../../../../context/LoaderProvider.jsx';
// import {
//     getAllCateringSettlementsAPI,
//     approveSettlementAPI,
//     generateSettlementRangeAPI,
// } from "../../../Servicefile/CateringSettlementService.jsx";

// // ============================================
// // PREMIUM ICONS COMPONENT
// // ============================================
// const Icons = {
//     Search: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
//         </svg>
//     ),
//     Export: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
//             <polyline points="7 10 12 15 17 10"/>
//             <line x1="12" y1="15" x2="12" y2="3"/>
//         </svg>
//     ),
//     Clear: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
//         </svg>
//     ),
//     Calendar: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
//             <line x1="16" y1="2" x2="16" y2="6"/>
//             <line x1="8" y1="2" x2="8" y2="6"/>
//             <line x1="3" y1="10" x2="21" y2="10"/>
//         </svg>
//     ),
//     Money: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0b5e42" strokeWidth="2">
//             <circle cx="12" cy="12" r="10"/>
//             <path d="M8 12h8"/>
//             <path d="M12 8v8"/>
//         </svg>
//     ),
//     Vendor: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
//             <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
//         </svg>
//     ),
//     Bank: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <rect x="2" y="6" width="20" height="14" rx="2"/>
//             <path d="M2 10h20"/>
//             <path d="M8 14v4"/>
//             <path d="M12 14v4"/>
//             <path d="M16 14v4"/>
//         </svg>
//     ),
//     Status: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <circle cx="12" cy="12" r="10"/>
//             <polyline points="12 6 12 12 16 14"/>
//         </svg>
//     ),
//     NoData: () => (
//         <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
//             <rect x="2" y="3" width="20" height="18" rx="2"/>
//             <line x1="8" y1="21" x2="16" y2="21"/>
//             <line x1="12" y1="17" x2="12" y2="21"/>
//             <path d="M8 7h8M8 11h6M8 15h4"/>
//         </svg>
//     ),
//     Refresh: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <path d="M23 4v6h-6M1 20v-6h6"/>
//             <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
//         </svg>
//     ),
//     Check: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
//             <polyline points="20 6 9 17 4 12"/>
//         </svg>
//     ),
//     Settlement: () => (
//         <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgb(230 109 51)" strokeWidth="2">
//             <circle cx="12" cy="12" r="10"/>
//             <path d="M8 12h8"/>
//             <path d="M12 8v8"/>
//         </svg>
//     ),
//     Send: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <line x1="22" y1="2" x2="11" y2="13"/>
//             <polygon points="22 2 15 22 11 13 2 9 22 2"/>
//         </svg>
//     )
// };

// // ============================================
// // PREMIUM STYLES
// // ============================================
// const styles = {
//     container: {
    
//         minHeight: '500px'
//     },
//     header: {
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '0 0 16px 0',
//         borderBottom: '2px solid #e9ecef',
//         flexWrap: 'wrap',
//         gap: '12px'
//     },
//     title: {
//         fontSize: '20px',
//         fontWeight: '600',
//         color: '#2d3748',
//         letterSpacing: '-0.3px',
//         display: 'flex',
//         alignItems: 'center',
//         gap: '10px'
//     },
//     titleBadge: {
//         background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
//         color: 'white',
//         fontSize: '12px',
//         fontWeight: '500',
//         padding: '2px 12px',
//         borderRadius: '12px',
//         letterSpacing: '0.3px'
//     },
//     statsContainer: {
//         display: 'grid',
//         gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
//         gap: '12px',
//         marginBottom: '16px',
//         padding: '16px',
//         background: 'white',
//         borderRadius: '12px',
//         border: '1px solid #edf2f7'
//     },
//     statItem: {
//         textAlign: 'center'
//     },
//     statValue: {
//         fontSize: '24px',
//         fontWeight: '700',
//         color: '#2d3748'
//     },
//     statLabel: {
//         fontSize: '12px',
//         color: '#718096',
//         fontWeight: '500',
//         textTransform: 'uppercase',
//         letterSpacing: '0.3px'
//     },
//     filtersContainer: {
//         display: 'flex',
//         flexWrap: 'wrap',
//         alignItems: 'center',
//         gap: '10px',
//         padding: '12px 0',
//         borderBottom: '1px solid #edf2f7',
//         marginBottom: '16px'
//     },
//     searchGroup: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '8px',
//         flex: '1 1 auto',
//         minWidth: '200px'
//     },
//     searchInput: {
//         flex: '1',
//         padding: '8px 14px 8px 38px',
//         border: '2px solid #e2e8f0',
//         borderRadius: '10px',
//         fontSize: '13px',
//         color: '#2d3748',
//         outline: 'none',
//         transition: 'all 0.3s ease',
//         height: '42px',
//         background: 'white',
//         minWidth: '160px'
//     },
//     dateInput: {
//         padding: '8px 14px',
//         border: '2px solid #e2e8f0',
//         borderRadius: '10px',
//         fontSize: '13px',
//         color: '#2d3748',
//         outline: 'none',
//         transition: 'all 0.3s ease',
//         height: '42px',
//         background: 'white',
//         minWidth: '150px'
//     },
//     button: {
//         padding: '8px 18px',
//         borderRadius: '10px',
//         border: 'none',
//         fontWeight: '600',
//         fontSize: '13px',
//         display: 'flex',
//         alignItems: 'center',
//         gap: '6px',
//         cursor: 'pointer',
//         transition: 'all 0.3s ease',
//         height: '42px',
//         whiteSpace: 'nowrap'
//     },
//     buttonPrimary: {
//         background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
//         color: 'white',
//         boxShadow: '0 4px 15px rgba(230, 109, 51, 0.3)'
//     },
//     buttonSecondary: {
//         background: '#e2e8f0',
//         color: '#4a5568'
//     },
//     buttonSuccess: {
//         background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
//         color: 'white',
//         boxShadow: '0 4px 15px rgba(40, 167, 69, 0.3)'
//     },
//     buttonExport: {
//         background: 'linear-gradient(135deg, #e66d33 0%, #e66d33 100%)',
//         color: 'white',
//         boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)'
//     },
//     buttonSend: {
//         background: 'linear-gradient(135deg, #1ca645 0%, #1ca645 0%)',
//         color: 'white',
//         boxShadow: '0 4px 15px rgba(245, 87, 108, 0.3)'
//     },
//     tableWrapper: {
//         borderRadius: '12px',
//         border: '1px solid #edf2f7',
//         background: 'white',
//         overflow: 'auto',
//         maxHeight: '500px',
//         position: 'relative'
//     },
//     table: {
//         width: '100%',
//         fontSize: '13px',
//         borderCollapse: 'collapse',
      
//     },
//     thead: {
//         position: 'sticky',
//         top: 0,
//         zIndex: 10
//     },
//     th: {
//         padding: '10px 12px',
//         textAlign: 'center',
//         fontWeight: '600',
//         fontSize: '11px',
//         textTransform: 'uppercase',
//         letterSpacing: '0.5px',
//         color: 'white',
//         background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
//         borderBottom: '2px solid #d45a1a',
//         whiteSpace: 'nowrap'
//     },
//     td: {
//         padding: '10px 12px',
//         borderBottom: '1px solid #f1f5f9',
//         color: '#2d3748',
//         fontSize: '13px',
//         textAlign: 'center',
//         verticalAlign: 'middle'
//     },
//     badge: {
//         display: 'inline-flex',
//         alignItems: 'center',
//         gap: '4px',
//         padding: '3px 12px',
//         borderRadius: '20px',
//         fontSize: '11px',
//         fontWeight: '600',
//         letterSpacing: '0.3px'
//     },
//     badgeApproved: {
//         background: '#c6f6d5',
//         color: '#276749'
//     },
//     badgePending: {
//         background: '#fefcbf',
//         color: '#975a16'
//     },
//     badgeDefault: {
//         background: '#e2e8f0',
//         color: '#4a5568'
//     },
//     amount: {
//         fontWeight: '600',
//         color: '#0b5e42'
//     },
//     amountNegative: {
//         fontWeight: '600',
//         color: '#dc3545'
//     },
//     emptyState: {
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         justifyContent: 'center',
//         padding: '60px 20px',
//         color: '#a0aec0'
//     },
//     emptyStateText: {
//         marginTop: '16px',
//         fontSize: '16px',
//         fontWeight: '500',
//         color: '#4a5568'
//     },
//     emptyStateSubtext: {
//         fontSize: '13px',
//         color: '#a0aec0',
//         marginTop: '4px'
//     },
//     approveButton: {
//         padding: '4px 14px',
//         borderRadius: '6px',
//         border: 'none',
//         fontSize: '12px',
//         fontWeight: '600',
//         cursor: 'pointer',
//         transition: 'all 0.3s ease',
//         minWidth: '80px',
//         whiteSpace: 'nowrap'
//     },
//     approveActive: {
//         background: '#48bb78',
//         color: 'white'
//     },
//     approveDisabled: {
//         background: '#a0aec0',
//         color: 'white',
//         cursor: 'not-allowed'
//     },
//     dateRangeGroup: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '8px',
//         flexWrap: 'wrap'
//     },
//     dateRangeText: {
//         color: '#718096',
//         fontSize: '13px',
//         fontWeight: '500'
//     }
// };

// const CateringSettelment = () => {
//     const [searchTerm, setSearchTerm] = useState("");
//     const [year, setYear] = useState("");
//     const [month, setMonth] = useState("");
//     const [selectedDate, setSelectedDate] = useState("");
//     const [invoiceData, setInvoiceData] = useState([]);
//     const { showLoader, hideLoader } = useLoader();
//     const [settlements, setSettlements] = useState([]);
//     const [filteredSettlements, setFilteredSettlements] = useState([]);
//     const [error, setError] = useState(null);
//     const [fromDate, setFromDate] = useState("");
//     const [toDate, setToDate] = useState("");
//     const [isMobile, setIsMobile] = useState(false);

//     useEffect(() => {
//         const checkMobile = () => setIsMobile(window.innerWidth < 768);
//         checkMobile();
//         window.addEventListener('resize', checkMobile);
//         return () => window.removeEventListener('resize', checkMobile);
//     }, []);

//     const handleApprove = async (settlementId) => {
//         try {
//             await approveSettlementAPI(settlementId);
//             alert("✅ Settlement approved successfully!");
//             // Refresh data
//             const data = await getAllCateringSettlementsAPI();
//             setSettlements(data);
//             setFilteredSettlements(data);
//         } catch (error) {
//             console.error("❌ Error approving settlement:", error);
//             let errorMsg = "❌ Failed to approve settlement.";
//             if (error.response) {
//                 errorMsg += `\nStatus: ${error.response.status}\nMessage: ${error.response.data?.message || "Unknown server error"}`;
//             } else if (error.request) {
//                 errorMsg += "\nNo response received from server.";
//             } else {
//                 errorMsg += `\nError: ${error.message}`;
//             }
//             alert(errorMsg);
//         }
//     };

//     const handleSend = async () => {
//         if (!fromDate || !toDate) {
//             alert("⚠️ Please select both From and To dates");
//             return;
//         }
//         try {
//             await generateSettlementRangeAPI(fromDate, toDate);
//             alert("✅ Data generated successfully!");
//             // Refresh data
//             const data = await getAllCateringSettlementsAPI();
//             setSettlements(data);
//             setFilteredSettlements(data);
//         } catch (error) {
//             console.error("❌ Error generating range:", error);
//             alert("❌ Failed to generate data. Check console for details.");
//         }
//     };

//     useEffect(() => {
//         const fetchSettlements = async () => {
//             try {
//                 showLoader();
//                 const data = await getAllCateringSettlementsAPI();
//                 setSettlements(data);
//                 setFilteredSettlements(data);
//             } catch (error) {
//                 console.error("❌ Error fetching settlements:", error);
//                 setError("Error fetching settlements. See console.");
//             } finally {
//                 hideLoader();
//             }
//         };
//         fetchSettlements();
//     }, []);

//     useEffect(() => {
//         let filtered = [...settlements];
//         if (searchTerm) {
//             filtered = filtered.filter((item) =>
//                 item.vendorId.toString().includes(searchTerm)
//             );
//         }
//         if (year) {
//             filtered = filtered.filter(
//                 (item) => new Date(item.settlementDate).getFullYear() === Number(year)
//             );
//         }
//         if (month) {
//             filtered = filtered.filter(
//                 (item) => new Date(item.settlementDate).getMonth() === Number(month)
//             );
//         }
//         if (selectedDate) {
//             filtered = filtered.filter(
//                 (item) => new Date(item.settlementDate).getDate() === Number(selectedDate)
//             );
//         }
//         setFilteredSettlements(filtered);
//     }, [searchTerm, year, month, selectedDate, settlements]);

//     const currentYear = new Date().getFullYear();
//     const years = Array.from({ length: currentYear - 2024 + 1 }, (_, i) => 2024 + i);
//     const monthsLabel = [
//         "January", "February", "March", "April", "May", "June",
//         "July", "August", "September", "October", "November", "December"
//     ];
//     const [daysInMonth, setDaysInMonth] = useState([]);

//     useEffect(() => {
//         const y = year ? Number(year) : currentYear;
//         const m = month !== "" ? Number(month) : new Date().getMonth();
//         const days = new Date(y, m + 1, 0).getDate();
//         setDaysInMonth(Array.from({ length: days }, (_, i) => i + 1));
//         if (selectedDate && (selectedDate < 1 || selectedDate > days)) {
//             setSelectedDate("");
//         }
//     }, [year, month, selectedDate]);

//     const handleExport = () => {
//         const headers = [
//             "Vendor ID", "Total Cgst", "Grand Total", "Total Sales",
//             "Service Charges", "To Settle", "Admin Acc", "Vendor Name",
//             "Vendor Acc", "IFSC", "Settlement Date", "Payment Status"
//         ];

//         const rows = filteredSettlements.map((it) => [
//             it.vendorId,
//             it.totalCgst,
//             it.totalGrandTotal,
//             it.totalAmountBeforeTds,
//             it.tdsAmount,
//             it.amountAfterTds,
//             it.superadminAccNo,
//             it.holderName,
//             it.accountNumber,
//             it.ifscCode,
//             it.settlementDate,
//             it.paymentStatus === "SUCCESS" ? "Approved" : "Pending"
//         ]);

//         const csvContent = [headers, ...rows].map((r) => r.join(",")).join("\n");
//         const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//         const link = document.createElement("a");
//         link.href = URL.createObjectURL(blob);
//         link.download = `catering_settlements_${new Date().toISOString().split('T')[0]}.csv`;
//         link.click();
//     };

//     const clearFilters = () => {
//         setSearchTerm("");
//         setYear("");
//         setMonth("");
//         setSelectedDate("");
//         setFromDate("");
//         setToDate("");
//     };

//     // Calculate stats
//     const totalSettlements = filteredSettlements.length;
//     const totalAmount = filteredSettlements.reduce((sum, item) => sum + (item.totalAmountBeforeTds || 0), 0);
//     const approvedCount = filteredSettlements.filter(item => item.paymentStatus === "SUCCESS").length;
//     const pendingCount = filteredSettlements.filter(item => item.paymentStatus !== "SUCCESS").length;

//     return (
//         <div style={styles.container}>
          
//             {/* Filters */}
//             <div style={styles.filtersContainer}>
//                 <div style={styles.searchGroup}>
//                     <div style={{ position: 'relative', flex: 1 }}>
                       
//                         <input
//                             type="text"
//                             placeholder="Search by Vendor ID..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             style={{
//                                 ...styles.searchInput,
//                                 borderColor: searchTerm ? '#e66d33' : '#e2e8f0'
//                             }}
//                             onFocus={(e) => {
//                                 e.target.style.borderColor = '#e66d33';
//                                 e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
//                             }}
//                             onBlur={(e) => {
//                                 e.target.style.borderColor = '#e2e8f0';
//                                 e.target.style.boxShadow = 'none';
//                             }}
//                         />
//                     </div>
//                 </div>

//                 <div style={styles.dateRangeGroup}>
//                     <Icons.Calendar />
//                     <input
//                         type="date"
//                         value={fromDate}
//                         onChange={(e) => setFromDate(e.target.value)}
//                         style={styles.dateInput}
//                     />
//                     <span style={styles.dateRangeText}>to</span>
//                     <input
//                         type="date"
//                         value={toDate}
//                         onChange={(e) => setToDate(e.target.value)}
//                         style={styles.dateInput}
//                     />
//                     <button
//                         onClick={handleSend}
//                         style={{ ...styles.button, ...styles.buttonSend }}
//                     >
//                         <Icons.Send /> Send
//                     </button>
//                 </div>

//                 <button
//                     onClick={clearFilters}
//                     style={{ ...styles.button, ...styles.buttonSecondary }}
//                 >
//                     <Icons.Clear /> Clear
//                 </button>

//                 <button
//                     onClick={handleExport}
//                     style={{ ...styles.button, ...styles.buttonExport }}
//                 >
//                     <Icons.Export /> Export
//                 </button>
//             </div>

//             {/* Table */}
//             <div style={styles.tableWrapper}>
//                 <table style={styles.table}>
//                     <thead style={styles.thead}>
//                         <tr>
//                             <th style={{ ...styles.th, width: '4%' }}>#</th>
//                             <th style={{ ...styles.th, width: '6%' }}>Vendor ID</th>
//                             <th style={{ ...styles.th, width: '6%' }}>Total Cgst</th>
//                             <th style={{ ...styles.th, width: '8%' }}>Grand Total</th>
//                             <th style={{ ...styles.th, width: '8%' }}>Total Sales</th>
//                             <th style={{ ...styles.th, width: '8%' }}>Service Charges</th>
//                             <th style={{ ...styles.th, width: '8%' }}>To Settle</th>
//                             <th style={{ ...styles.th, width: '8%' }}>Admin Acc</th>
//                             <th style={{ ...styles.th, width: '8%' }}>Vendor Name</th>
//                             <th style={{ ...styles.th, width: '8%' }}>Vendor Acc</th>
//                             <th style={{ ...styles.th, width: '6%' }}>IFSC</th>
//                             <th style={{ ...styles.th, width: '8%' }}>Settle Date</th>
//                             <th style={{ ...styles.th, width: '6%', textAlign: 'center' }}>Action</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {filteredSettlements.length > 0 ? (
//                             filteredSettlements.map((it, index) => (
//                                 <tr
//                                     key={it.adminId || index}
//                                     style={{
//                                         backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafbfc',
//                                         transition: 'background 0.15s ease'
//                                     }}
//                                     onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
//                                     onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#fafbfc'}
//                                 >
//                                     <td style={{ ...styles.td, color: '#a0aec0' }}>{index + 1}</td>
//                                     <td style={{ ...styles.td, fontFamily: 'monospace', fontSize: '12px' }}>{it.vendorId}</td>
//                                     <td style={styles.td}>₹{it.totalCgst}</td>
//                                     <td style={{ ...styles.td, ...styles.amount }}>₹{it.totalGrandTotal}</td>
//                                     <td style={{ ...styles.td, ...styles.amount }}>₹{it.totalAmountBeforeTds}</td>
//                                     <td style={{ ...styles.td, ...styles.amountNegative }}>-₹{it.tdsAmount}</td>
//                                     <td style={{ ...styles.td, ...styles.amount }}>₹{it.amountAfterTds}</td>
//                                     <td style={{ ...styles.td, fontFamily: 'monospace', fontSize: '12px' }}>{it.superadminAccNo}</td>
//                                     <td style={{ ...styles.td, fontWeight: '500' }}>{it.holderName}</td>
//                                     <td style={{ ...styles.td, fontFamily: 'monospace', fontSize: '12px' }}>{it.accountNumber}</td>
//                                     <td style={{ ...styles.td, fontFamily: 'monospace', fontSize: '12px' }}>{it.ifscCode}</td>
//                                     <td style={styles.td}>{it.settlementDate}</td>
//                                     <td style={styles.td}>
//                                         {it.paymentStatus === "SUCCESS" ? (
//                                             <span style={{ ...styles.badge, ...styles.badgeApproved }}>
//                                                 <Icons.Check /> Approved
//                                             </span>
//                                         ) : (
//                                             <button
//                                                 onClick={() => handleApprove(it.settlementId)}
//                                                 style={{ ...styles.approveButton, ...styles.approveActive }}
//                                             >
//                                                 Approve
//                                             </button>
//                                         )}
//                                     </td>
//                                 </tr>
//                             ))
//                         ) : (
//                             <tr>
//                                 <td colSpan="13" style={{ padding: 0 }}>
//                                     <div style={styles.emptyState}>
//                                         <Icons.NoData />
//                                         <div style={styles.emptyStateText}>
//                                             {settlements.length === 0 ? 'Loading settlements...' : 'No settlements found'}
//                                         </div>
//                                         <div style={styles.emptyStateSubtext}>
//                                             {settlements.length === 0
//                                                 ? 'Please wait while we fetch the data'
//                                                 : (searchTerm || fromDate || toDate)
//                                                     ? 'Try adjusting your filters to see more results'
//                                                     : 'No catering settlements are available'}
//                                         </div>
//                                     </div>
//                                 </td>
//                             </tr>
//                         )}
//                     </tbody>
//                 </table>
//             </div>

//             <style>{`
//                 @media (max-width: 768px) {
//                     .filters-container {
//                         flex-direction: column !important;
//                         align-items: stretch !important;
//                     }
//                     .search-group {
//                         min-width: unset !important;
//                     }
//                     .stats-container {
//                         grid-template-columns: 1fr 1fr !important;
//                     }
//                     .date-range-group {
//                         flex-wrap: wrap !important;
//                     }
//                     .date-range-group input {
//                         flex: 1 !important;
//                         min-width: 120px !important;
//                     }
//                     .table-container table {
//                         font-size: 12px !important;
//                     }
//                     .table-container table th,
//                     .table-container table td {
//                         padding: 8px 10px !important;
//                         font-size: 11px !important;
//                     }
//                 }

//                 @media (max-width: 480px) {
//                     .stats-container {
//                         grid-template-columns: 1fr !important;
//                     }
//                     .stat-value {
//                         font-size: 18px !important;
//                     }
//                     .table-container table {
//                         font-size: 10px !important;
//                         min-width: 900px !important;
//                     }
//                     .table-container table th,
//                     .table-container table td {
//                         padding: 4px 6px !important;
//                         font-size: 9px !important;
//                     }
//                     .badge {
//                         font-size: 8px !important;
//                         padding: 1px 6px !important;
//                     }
//                     .approve-button {
//                         font-size: 9px !important;
//                         padding: 2px 8px !important;
//                         min-width: 50px !important;
//                     }
//                     .date-range-group input {
//                         min-width: 80px !important;
//                         font-size: 11px !important;
//                         padding: 4px 8px !important;
//                         height: 32px !important;
//                     }
//                     .date-range-group span {
//                         font-size: 11px !important;
//                     }
//                 }

//                 ::-webkit-scrollbar {
//                     width: 6px;
//                     height: 6px;
//                 }
//                 ::-webkit-scrollbar-track {
//                     background: #f1f1f1;
//                     border-radius: 4px;
//                 }
//                 ::-webkit-scrollbar-thumb {
//                     background: linear-gradient(135deg, #e66d33 0%, #d45a2a 100%);
//                     border-radius: 4px;
//                 }
//                 ::-webkit-scrollbar-thumb:hover {
//                     background: linear-gradient(135deg, #d45a2a 0%, #b84a1a 100%);
//                 }
//             `}</style>
//         </div>
//     );
// };

// export default CateringSettelment;




import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import {
    getAllCateringSettlementsAPI,
    approveSettlementAPI,
    generateSettlementRangeAPI,
} from "../../../Servicefile/CateringSettlementService.jsx";

// ============================================
// PREMIUM ICONS COMPONENT
// ============================================
const Icons = {
    Search: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
        </svg>
    ),
    Export: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7 10 12 15 17 10"/>
            <line x1="12" y1="15" x2="12" y2="3"/>
        </svg>
    ),
    Clear: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
    ),
    Calendar: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
            <line x1="16" y1="2" x2="16" y2="6"/>
            <line x1="8" y1="2" x2="8" y2="6"/>
            <line x1="3" y1="10" x2="21" y2="10"/>
        </svg>
    ),
    Money: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0b5e42" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <path d="M8 12h8"/>
            <path d="M12 8v8"/>
        </svg>
    ),
    Vendor: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
        </svg>
    ),
    Bank: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="6" width="20" height="14" rx="2"/>
            <path d="M2 10h20"/>
            <path d="M8 14v4"/>
            <path d="M12 14v4"/>
            <path d="M16 14v4"/>
        </svg>
    ),
    Status: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
        </svg>
    ),
    NoData: () => (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
            <rect x="2" y="3" width="20" height="18" rx="2"/>
            <line x1="8" y1="21" x2="16" y2="21"/>
            <line x1="12" y1="17" x2="12" y2="21"/>
            <path d="M8 7h8M8 11h6M8 15h4"/>
        </svg>
    ),
    Refresh: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M23 4v6h-6M1 20v-6h6"/>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
        </svg>
    ),
    Check: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
            <polyline points="20 6 9 17 4 12"/>
        </svg>
    ),
    Settlement: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgb(230 109 51)" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <path d="M8 12h8"/>
            <path d="M12 8v8"/>
        </svg>
    ),
    Send: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="22" y1="2" x2="11" y2="13"/>
            <polygon points="22 2 15 22 11 13 2 9 22 2"/>
        </svg>
    ),
    TrendingUp: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
            <polyline points="17 6 23 6 23 12"/>
        </svg>
    ),
    TrendingDown: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="23 18 13.5 8.5 8.5 13.5 1 6"/>
            <polyline points="17 18 23 18 23 12"/>
        </svg>
    ),
    Wallet: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
            <line x1="1" y1="10" x2="23" y2="10"/>
        </svg>
    ),
    CheckCircle: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#28a745" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
            <polyline points="22 4 12 14.01 9 11.01"/>
        </svg>
    ),
    Clock: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ffc107" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
        </svg>
    ),
    Building: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="4" y="2" width="16" height="20" rx="2" ry="2"/>
            <line x1="9" y1="22" x2="15" y2="22"/>
            <line x1="9" y1="6" x2="15" y2="6"/>
            <line x1="9" y1="10" x2="15" y2="10"/>
            <line x1="9" y1="14" x2="15" y2="14"/>
        </svg>
    ),
    User: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
        </svg>
    )
};

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    container: {
        padding: '11px 5px',
        width: '100%',
        maxWidth: '100%',
        overflowX: 'hidden'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 0 16px 0',
        borderBottom: '2px solid #e9ecef',
        flexWrap: 'wrap',
        gap: '12px'
    },
    title: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    titleBadge: {
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    statsContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
        gap: '14px',
        marginBottom: '16px',
        padding: '18px',
        background: 'white',
        borderRadius: '14px',
        border: '1px solid #edf2f7',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
    },
    statItem: {
        textAlign: 'center',
        padding: '4px 0',
        borderRadius: '10px',
        transition: 'all 0.3s ease',
        cursor: 'default'
    },
    statValue: {
        fontSize: '26px',
        fontWeight: '700',
        color: '#2d3748',
        lineHeight: '1.2'
    },
    statLabel: {
        fontSize: '12px',
        color: '#718096',
        fontWeight: '500',
        textTransform: 'uppercase',
        letterSpacing: '0.4px',
        marginTop: '4px'
    },
    filtersContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '10px',
        padding: '12px 0',
        borderBottom: '1px solid #edf2f7',
        marginBottom: '16px'
    },
    searchGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flex: '1 1 auto',
        minWidth: '280px'
    },
    searchInput: {
        flex: '1',
        padding: '8px 14px 8px 38px',
        border: '2px solid #e2e8f0',
        borderRadius: '10px',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.3s ease',
        height: '42px',
        background: 'white',
        minWidth: '180px'
    },
    dateInput: {
        padding: '8px 14px',
        border: '2px solid #e2e8f0',
        borderRadius: '10px',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.3s ease',
        height: '42px',
        background: 'white',
        minWidth: '150px'
    },
    selectInput: {
        padding: '8px 14px',
        border: '2px solid #e2e8f0',
        borderRadius: '10px',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.3s ease',
        height: '42px',
        background: 'white',
        minWidth: '130px',
        cursor: 'pointer'
    },
    button: {
        padding: '8px 18px',
        borderRadius: '10px',
        border: 'none',
        fontWeight: '600',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        height: '42px',
        whiteSpace: 'nowrap'
    },
    buttonPrimary: {
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        color: 'white',
        boxShadow: '0 4px 15px rgba(230, 109, 51, 0.3)'
    },
    buttonSecondary: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    buttonSuccess: {
        background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
        color: 'white',
        boxShadow: '0 4px 15px rgba(40, 167, 69, 0.3)'
    },
    buttonExport: {
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        color: 'white',
        boxShadow: '0 4px 15px rgba(230, 109, 51, 0.3)'
    },
    buttonSend: {
        background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
        color: 'white',
        boxShadow: '0 4px 15px rgba(40, 167, 69, 0.3)'
    },
    tableWrapper: {
        borderRadius: '12px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflow: 'auto',
        maxHeight: '60vh',
        position: 'relative',
        width: '100%',
        maxWidth: '100%'
    },
    table: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '1400px'
    },
    thead: {
        position: 'sticky',
        top: 0,
        zIndex: 10
    },
    th: {
        padding: '10px 12px',
        textAlign: 'center',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        borderBottom: '2px solid #d45a1a',
        whiteSpace: 'nowrap'
    },
    td: {
        padding: '10px 12px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '13px',
        textAlign: 'center',
        verticalAlign: 'middle'
    },
    badge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '3px 12px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: '600',
        letterSpacing: '0.3px'
    },
    badgeApproved: {
        background: '#c6f6d5',
        color: '#276749'
    },
    badgePending: {
        background: '#fefcbf',
        color: '#975a16'
    },
    badgeDefault: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    amount: {
        fontWeight: '600',
        color: '#0b5e42'
    },
    amountNegative: {
        fontWeight: '600',
        color: '#dc3545'
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        color: '#a0aec0'
    },
    emptyStateText: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#4a5568'
    },
    emptyStateSubtext: {
        fontSize: '13px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    approveButton: {
        padding: '4px 14px',
        borderRadius: '6px',
        border: 'none',
        fontSize: '12px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        minWidth: '80px',
        whiteSpace: 'nowrap'
    },
    approveActive: {
        background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
        color: 'white',
        boxShadow: '0 2px 8px rgba(40, 167, 69, 0.3)'
    },
    approveDisabled: {
        background: '#a0aec0',
        color: 'white',
        cursor: 'not-allowed'
    },
    dateRangeGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flexWrap: 'wrap'
    },
    dateRangeText: {
        color: '#718096',
        fontSize: '13px',
        fontWeight: '500'
    },
    
    // Vendor Dashboard Card Styles
    vendorDashboardGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: '20px',
        marginBottom: '20px'
    },
    vendorCard: {
        background: 'white',
        borderRadius: '16px',
        border: '1px solid #edf2f7',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
        overflow: 'hidden',
        transition: 'all 0.3s ease'
    },
    vendorCardHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '16px 24px',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        flexWrap: 'wrap',
        gap: '12px'
    },
    vendorCardHeaderLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: '14px'
    },
    vendorAvatar: {
        width: '48px',
        height: '48px',
        borderRadius: '50%',
        background: 'rgba(255,255,255,0.2)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '24px',
        color: 'white',
        backdropFilter: 'blur(10px)'
    },
    vendorHeaderInfo: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px'
    },
    vendorHeaderName: {
        margin: 0,
        fontSize: '18px',
        fontWeight: '700',
        color: 'white'
    },
    vendorHeaderId: {
        fontSize: '12px',
        color: 'rgba(255,255,255,0.7)'
    },
    vendorHeaderRight: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        flexWrap: 'wrap'
    },
    vendorHeaderStat: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '4px 12px',
        borderRadius: '12px',
        background: 'rgba(255,255,255,0.15)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500'
    },
    vendorHeaderStatApproved: {
        background: 'rgba(40, 167, 69, 0.3)',
        color: '#a8e6cf'
    },
    vendorHeaderStatPending: {
        background: 'rgba(255, 193, 7, 0.3)',
        color: '#ffd93d'
    },
    expandIcon: {
        color: 'white',
        fontSize: '20px',
        fontWeight: '700',
        marginLeft: '5px',
        transition: 'transform 0.3s ease'
    },
    expandIconRotated: {
        transform: 'rotate(180deg)'
    },

    // Vendor Dashboard Body
    vendorDashboardBody: {
        padding: '20px 24px 24px 24px',
        animation: 'slideDown 0.3s ease'
    },

    // KPI Cards Grid
    kpiGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: '14px',
        marginBottom: '20px'
    },
    kpiCard: {
        background: '#f8f9fa',
        borderRadius: '12px',
        padding: '16px',
        border: '1px solid #edf2f7',
        transition: 'all 0.3s ease'
    },
    kpiLabel: {
        fontSize: '11px',
        fontWeight: '600',
        color: '#718096',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        marginBottom: '6px'
    },
    kpiValue: {
        fontSize: '24px',
        fontWeight: '700',
        color: '#2d3748'
    },
    kpiSubtext: {
        fontSize: '12px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    kpiIcon: {
        fontSize: '20px',
        marginBottom: '4px'
    },

    // Vendor Details Section
    vendorDetailsGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '16px',
        marginBottom: '20px'
    },
    vendorDetailCard: {
        background: '#f8f9fa',
        borderRadius: '12px',
        padding: '16px',
        border: '1px solid #edf2f7'
    },
    vendorDetailTitle: {
        fontSize: '13px',
        fontWeight: '600',
        color: '#4a5568',
        marginBottom: '10px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    },
    vendorDetailRow: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '6px 0',
        borderBottom: '1px solid #e9ecef',
        fontSize: '13px'
    },
    vendorDetailRowLast: {
        borderBottom: 'none'
    },
    vendorDetailLabel: {
        color: '#718096'
    },
    vendorDetailValue: {
        fontWeight: '500',
        color: '#2d3748'
    },

    // Settlement Items Table inside Vendor Card
    vendorSettlementTable: {
        width: '100%',
        fontSize: '12px',
        borderCollapse: 'collapse',
        marginTop: '10px'
    },
    vendorSettlementHeader: {
        padding: '8px 10px',
        textAlign: 'left',
        fontWeight: '600',
        fontSize: '10px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: '#718096',
        borderBottom: '2px solid #edf2f7'
    },
    vendorSettlementCell: {
        padding: '8px 10px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '12px'
    },
    vendorSettlementAction: {
        padding: '4px 12px',
        borderRadius: '6px',
        border: 'none',
        fontWeight: '600',
        fontSize: '11px',
        cursor: 'pointer',
        transition: 'all 0.3s ease'
    },

    // Date Filter Section
    dateFilterSection: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '10px',
        padding: '12px 16px',
        background: '#f8f9fa',
        borderRadius: '10px',
        marginBottom: '16px',
        border: '1px solid #edf2f7'
    },
    dateFilterButton: {
        padding: '6px 16px',
        borderRadius: '20px',
        border: '2px solid #e2e8f0',
        background: 'white',
        fontSize: '12px',
        fontWeight: '500',
        color: '#4a5568',
        cursor: 'pointer',
        transition: 'all 0.3s ease'
    },
    dateFilterButtonActive: {
        borderColor: '#e66d33',
        background: '#e66d33',
        color: 'white'
    },
    dateFilterDivider: {
        color: '#e2e8f0',
        fontSize: '18px',
        fontWeight: '300'
    }
};

// ============================================
// VENDOR DASHBOARD CARD COMPONENT
// ============================================
const VendorDashboardCard = ({ vendorId, vendorData, onApprove, onUpdateStatus }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isApproving, setIsApproving] = useState(false);

    const toggleExpand = () => setIsExpanded(!isExpanded);

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount || 0);
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toISOString().split('T')[0];
    };

    const getStatusBadge = (status) => {
        if (status === "SUCCESS") return styles.badgeApproved;
        return styles.badgePending;
    };

    // Calculate KPIs
    const totalSettlements = vendorData.length;
    const totalGrandTotal = vendorData.reduce((sum, item) => sum + (item.totalGrandTotal || 0), 0);
    const totalSales = vendorData.reduce((sum, item) => sum + (item.totalAmountBeforeTds || 0), 0);
    const totalServiceCharges = vendorData.reduce((sum, item) => sum + (item.tdsAmount || 0), 0);
    const totalToSettle = vendorData.reduce((sum, item) => sum + (item.amountAfterTds || 0), 0);
    const approvedCount = vendorData.filter(item => item.paymentStatus === "SUCCESS").length;
    const pendingCount = vendorData.filter(item => item.paymentStatus !== "SUCCESS").length;

    const handleApproveClick = async (settlementId) => {
        setIsApproving(true);
        await onApprove(settlementId);
        setIsApproving(false);
        onUpdateStatus();
    };

    return (
        <div style={styles.vendorCard}>
            {/* Vendor Card Header - Click to Expand */}
            <div style={styles.vendorCardHeader} onClick={toggleExpand}>
                <div style={styles.vendorCardHeaderLeft}>
                    <div style={styles.vendorAvatar}>
                        {vendorData[0]?.vendorLogo || '🏪'}
                    </div>
                    <div style={styles.vendorHeaderInfo}>
                        <h3 style={styles.vendorHeaderName}>
                            {vendorData[0]?.holderName || vendorId}
                        </h3>
                        <div style={styles.vendorHeaderId}>
                            Vendor ID: {vendorId}
                        </div>
                        <div style={styles.vendorHeaderId}>
                            Admin Acc: {vendorData[0]?.superadminAccNo || 'N/A'}
                        </div>
                    </div>
                </div>
                <div style={styles.vendorHeaderRight}>
                    <span style={{...styles.vendorHeaderStat, ...styles.vendorHeaderStatPending}}>
                        <Icons.Clock /> {pendingCount} Pending
                    </span>
                    <span style={{...styles.vendorHeaderStat, ...styles.vendorHeaderStatApproved}}>
                        <Icons.CheckCircle /> {approvedCount} Approved
                    </span>
                    <span style={{...styles.vendorHeaderStat}}>
                        <Icons.Money /> {formatCurrency(totalToSettle)}
                    </span>
                    <span style={{
                        ...styles.expandIcon,
                        ...(isExpanded ? styles.expandIconRotated : {})
                    }}>
                        ▼
                    </span>
                </div>
            </div>

            {/* Expanded Content - Vendor Dashboard */}
            {isExpanded && (
                <div style={styles.vendorDashboardBody}>
                    {/* KPI Cards Grid */}
                    <div style={styles.kpiGrid}>
                        <div style={styles.kpiCard}>
                            <div style={styles.kpiIcon}>📊</div>
                            <div style={styles.kpiLabel}>Total Settlements</div>
                            <div style={styles.kpiValue}>{totalSettlements}</div>
                        </div>
                        <div style={styles.kpiCard}>
                            <div style={styles.kpiIcon}>💰</div>
                            <div style={styles.kpiLabel}>Grand Total</div>
                            <div style={styles.kpiValue}>{formatCurrency(totalGrandTotal)}</div>
                        </div>
                        <div style={styles.kpiCard}>
                            <div style={styles.kpiIcon}>📈</div>
                            <div style={styles.kpiLabel}>Total Sales</div>
                            <div style={styles.kpiValue}>{formatCurrency(totalSales)}</div>
                        </div>
                        <div style={styles.kpiCard}>
                            <div style={styles.kpiIcon}>💳</div>
                            <div style={styles.kpiLabel}>Service Charges</div>
                            <div style={{...styles.kpiValue, color: '#dc3545'}}>
                                {formatCurrency(totalServiceCharges)}
                            </div>
                        </div>
                        <div style={styles.kpiCard}>
                            <div style={styles.kpiIcon}>🏦</div>
                            <div style={styles.kpiLabel}>To Settle</div>
                            <div style={{...styles.kpiValue, color: '#28a745'}}>
                                {formatCurrency(totalToSettle)}
                            </div>
                        </div>
                        <div style={styles.kpiCard}>
                            <div style={styles.kpiIcon}>✅</div>
                            <div style={styles.kpiLabel}>Approved</div>
                            <div style={styles.kpiValue}>{approvedCount}</div>
                            <div style={styles.kpiSubtext}>{formatCurrency(totalToSettle * (approvedCount / (totalSettlements || 1)))}</div>
                        </div>
                    </div>

                    {/* Vendor Details */}
                    <div style={styles.vendorDetailsGrid}>
                        <div style={styles.vendorDetailCard}>
                            <div style={styles.vendorDetailTitle}>
                                <Icons.User /> Vendor Details
                            </div>
                            <div style={styles.vendorDetailRow}>
                                <span style={styles.vendorDetailLabel}>Vendor ID</span>
                                <span style={styles.vendorDetailValue}>{vendorId}</span>
                            </div>
                            <div style={styles.vendorDetailRow}>
                                <span style={styles.vendorDetailLabel}>Vendor Name</span>
                                <span style={styles.vendorDetailValue}>{vendorData[0]?.holderName || '-'}</span>
                            </div>
                            <div style={styles.vendorDetailRow}>
                                <span style={styles.vendorDetailLabel}>Admin Account</span>
                                <span style={styles.vendorDetailValue}>{vendorData[0]?.superadminAccNo || '-'}</span>
                            </div>
                            <div style={{...styles.vendorDetailRow, ...styles.vendorDetailRowLast}}>
                                <span style={styles.vendorDetailLabel}>Total CGST</span>
                                <span style={styles.vendorDetailValue}>{formatCurrency(vendorData.reduce((sum, item) => sum + (item.totalCgst || 0), 0))}</span>
                            </div>
                        </div>
                        <div style={styles.vendorDetailCard}>
                            <div style={styles.vendorDetailTitle}>
                                <Icons.Bank /> Bank Details
                            </div>
                            <div style={styles.vendorDetailRow}>
                                <span style={styles.vendorDetailLabel}>Account Holder</span>
                                <span style={styles.vendorDetailValue}>{vendorData[0]?.holderName || '-'}</span>
                            </div>
                            <div style={styles.vendorDetailRow}>
                                <span style={styles.vendorDetailLabel}>Account Number</span>
                                <span style={styles.vendorDetailValue}>{vendorData[0]?.accountNumber || '-'}</span>
                            </div>
                            <div style={{...styles.vendorDetailRow, ...styles.vendorDetailRowLast}}>
                                <span style={styles.vendorDetailLabel}>IFSC Code</span>
                                <span style={styles.vendorDetailValue}>{vendorData[0]?.ifscCode || '-'}</span>
                            </div>
                        </div>
                    </div>

                    {/* Settlement Items Table */}
                    <div style={{...styles.vendorDetailCard, padding: '0', background: 'white'}}>
                        <div style={{...styles.vendorDetailTitle, padding: '16px 16px 0 16px'}}>
                            <Icons.Settlement /> Settlement History
                        </div>
                        <div style={{overflowX: 'auto'}}>
                            <table style={styles.vendorSettlementTable}>
                                <thead>
                                    <tr>
                                        <th style={styles.vendorSettlementHeader}>#</th>
                                        <th style={styles.vendorSettlementHeader}>Settlement ID</th>
                                        <th style={styles.vendorSettlementHeader}>Grand Total</th>
                                        <th style={styles.vendorSettlementHeader}>Sales</th>
                                        <th style={styles.vendorSettlementHeader}>Service Charges</th>
                                        <th style={styles.vendorSettlementHeader}>To Settle</th>
                                        <th style={styles.vendorSettlementHeader}>Settle Date</th>
                                        <th style={styles.vendorSettlementHeader}>Status</th>
                                        <th style={styles.vendorSettlementHeader}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {vendorData.map((item, index) => (
                                        <tr key={item.settlementId || index}>
                                            <td style={styles.vendorSettlementCell}>{index + 1}</td>
                                            <td style={{...styles.vendorSettlementCell, fontFamily: 'monospace', fontSize: '11px'}}>
                                                {item.settlementId}
                                            </td>
                                            <td style={{...styles.vendorSettlementCell, fontWeight: '600', color: '#0b5e42'}}>
                                                {formatCurrency(item.totalGrandTotal)}
                                            </td>
                                            <td style={styles.vendorSettlementCell}>{formatCurrency(item.totalAmountBeforeTds)}</td>
                                            <td style={{...styles.vendorSettlementCell, color: '#dc3545'}}>
                                                {formatCurrency(item.tdsAmount)}
                                            </td>
                                            <td style={{...styles.vendorSettlementCell, fontWeight: '600', color: '#28a745'}}>
                                                {formatCurrency(item.amountAfterTds)}
                                            </td>
                                            <td style={styles.vendorSettlementCell}>{formatDate(item.settlementDate)}</td>
                                            <td style={styles.vendorSettlementCell}>
                                                <span style={{...styles.badge, ...getStatusBadge(item.paymentStatus)}}>
                                                    {item.paymentStatus === "SUCCESS" ? '✅ Approved' : '⏳ Pending'}
                                                </span>
                                            </td>
                                            <td style={styles.vendorSettlementCell}>
                                                {item.paymentStatus !== "SUCCESS" ? (
                                                    <button
                                                        onClick={() => handleApproveClick(item.settlementId)}
                                                        disabled={isApproving}
                                                        style={{
                                                            ...styles.vendorSettlementAction,
                                                            background: isApproving ? '#a0aec0' : 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                                                            color: 'white'
                                                        }}
                                                    >
                                                        {isApproving ? '⏳' : '✅ Approve'}
                                                    </button>
                                                ) : (
                                                    <span style={{color: '#48bb78', fontWeight: '600', fontSize: '11px'}}>
                                                        ✓ Done
                                                    </span>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

// ============================================
// MAIN COMPONENT - CateringSettelment
// ============================================
const CateringSettelment = () => {
    const [searchType, setSearchType] = useState("vendorId");
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
    const [dateFilterType, setDateFilterType] = useState("all");
    const [customStartDate, setCustomStartDate] = useState("");
    const [customEndDate, setCustomEndDate] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    const searchOptions = [
        { value: "vendorId", label: "Vendor ID" },
        { value: "holderName", label: "Vendor Name" },
        { value: "accountNumber", label: "Account Number" },
        { value: "ifscCode", label: "IFSC Code" },
        { value: "settlementId", label: "Settlement ID" }
    ];

    const statusOptions = [
        { value: "", label: "All Status" },
        { value: "SUCCESS", label: "Approved" },
        { value: "PENDING", label: "Pending" }
    ];

    const [settlements, setSettlements] = useState([]);
    const [vendorGroups, setVendorGroups] = useState({});
    const [filteredVendorGroups, setFilteredVendorGroups] = useState({});
    const [error, setError] = useState(null);

    const { showLoader, hideLoader } = useLoader();

    useEffect(() => {
        fetchSettlements();
    }, []);

    const fetchSettlements = async () => {
        try {
            showLoader();
            const data = await getAllCateringSettlementsAPI();
            setSettlements(data);
            groupByVendor(data);
        } catch (error) {
            console.error("Error fetching settlements:", error);
            setError("Error fetching settlements. See console.");
        } finally {
            hideLoader();
        }
    };

    const groupByVendor = (data) => {
        const grouped = data.reduce((acc, item) => {
            const vendorId = item.vendorId;
            if (!acc[vendorId]) {
                acc[vendorId] = [];
            }
            acc[vendorId].push(item);
            return acc;
        }, {});
        setVendorGroups(grouped);
        setFilteredVendorGroups(grouped);
    };

    const getPlaceholderText = () => {
        switch (searchType) {
            case "vendorId": return "Search by Vendor ID...";
            case "holderName": return "Search by Vendor Name...";
            case "accountNumber": return "Search by Account Number...";
            case "ifscCode": return "Search by IFSC Code...";
            case "settlementId": return "Search by Settlement ID...";
            default: return "Search...";
        }
    };

    // Date filter logic
    const applyDateFilter = (data) => {
        if (dateFilterType === "all") return data;

        const now = new Date();
        let startDate = new Date();
        let endDate = new Date();

        switch (dateFilterType) {
            case "today":
                startDate = new Date(now.setHours(0, 0, 0, 0));
                endDate = new Date(now.setHours(23, 59, 59, 999));
                break;
            case "week":
                const day = now.getDay();
                startDate = new Date(now);
                startDate.setDate(now.getDate() - day);
                startDate.setHours(0, 0, 0, 0);
                endDate = new Date(now);
                endDate.setDate(now.getDate() + (6 - day));
                endDate.setHours(23, 59, 59, 999);
                break;
            case "month":
                startDate = new Date(now.getFullYear(), now.getMonth(), 1);
                endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
                break;
            case "custom":
                if (customStartDate && customEndDate) {
                    startDate = new Date(customStartDate);
                    endDate = new Date(customEndDate);
                    endDate.setHours(23, 59, 59, 999);
                } else {
                    return data;
                }
                break;
            default:
                return data;
        }

        return data.filter(item => {
            const settlementDate = new Date(item.settlementDate || item.fromDate);
            return settlementDate >= startDate && settlementDate <= endDate;
        });
    };

    // Handle Send/Generate Range
    const handleSend = async () => {
        if (!fromDate || !toDate) {
            alert("⚠️ Please select both From and To dates");
            return;
        }
        try {
            showLoader();
            await generateSettlementRangeAPI(fromDate, toDate);
            alert("✅ Data generated successfully!");
            await fetchSettlements();
        } catch (error) {
            console.error("❌ Error generating range:", error);
            alert("❌ Failed to generate data. Check console for details.");
        } finally {
            hideLoader();
        }
    };

    // Handle Approve
    const handleApprove = async (settlementId) => {
        try {
            showLoader();
            await approveSettlementAPI(settlementId);
            alert("✅ Settlement approved successfully!");
            await fetchSettlements();
        } catch (error) {
            console.error("❌ Error approving settlement:", error);
            let errorMsg = "❌ Failed to approve settlement.";
            if (error.response) {
                errorMsg += `\nStatus: ${error.response.status}\nMessage: ${error.response.data?.message || "Unknown server error"}`;
            } else if (error.request) {
                errorMsg += "\nNo response received from server.";
            } else {
                errorMsg += `\nError: ${error.message}`;
            }
            alert(errorMsg);
        } finally {
            hideLoader();
        }
    };

    const applyFilters = useMemo(() => {
        let filtered = { ...vendorGroups };

        // Search filter
        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();
            const filteredKeys = Object.keys(filtered).filter(vendorId => {
                const items = filtered[vendorId];
                return items.some(item => {
                    const fieldValue = item[searchType];
                    return fieldValue && fieldValue.toString().toLowerCase().includes(query);
                });
            });
            filtered = Object.fromEntries(
                Object.entries(filtered).filter(([key]) => filteredKeys.includes(key))
            );
        }

        // Status filter
        if (selectedStatusFilter) {
            const filteredKeys = Object.keys(filtered).filter(vendorId => {
                const items = filtered[vendorId];
                return items.some(item => item.paymentStatus === selectedStatusFilter);
            });
            filtered = Object.fromEntries(
                Object.entries(filtered).filter(([key]) => filteredKeys.includes(key))
            );
        }

        // Date filter
        const dateFiltered = Object.fromEntries(
            Object.entries(filtered).map(([vendorId, items]) => {
                const filteredItems = applyDateFilter(items);
                return [vendorId, filteredItems];
            }).filter(([_, items]) => items.length > 0)
        );

        return dateFiltered;
    }, [vendorGroups, searchQuery, searchType, selectedStatusFilter, dateFilterType, customStartDate, customEndDate]);

    useEffect(() => {
        setFilteredVendorGroups(applyFilters);
    }, [applyFilters]);

    const clearAllFilters = () => {
        setSearchQuery("");
        setSelectedStatusFilter("");
        setDateFilterType("all");
        setCustomStartDate("");
        setCustomEndDate("");
        setFromDate("");
        setToDate("");
    };

    const handleExport = () => {
        const allItems = Object.values(vendorGroups).flat();
        if (allItems.length === 0) {
            alert("No data available for export.");
            return;
        }

        const headers = [
            "Vendor ID", "Total Cgst", "Grand Total", "Total Sales",
            "Service Charges", "To Settle", "Admin Acc", "Vendor Name",
            "Vendor Acc", "IFSC", "Settlement Date", "Payment Status"
        ];

        const rows = allItems.map((it) => [
            it.vendorId,
            it.totalCgst,
            it.totalGrandTotal,
            it.totalAmountBeforeTds,
            it.tdsAmount,
            it.amountAfterTds,
            it.superadminAccNo,
            it.holderName,
            it.accountNumber,
            it.ifscCode,
            it.settlementDate,
            it.paymentStatus === "SUCCESS" ? "Approved" : "Pending"
        ]);

        const csvContent = [headers, ...rows].map((r) => r.join(",")).join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `catering_settlements_${new Date().toISOString().split('T')[0]}.csv`;
        link.click();
    };

    const formatDate = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        return date.toISOString().split("T")[0];
    };

    // Calculate overall stats
    const allItems = Object.values(vendorGroups).flat();
    const totalSettlements = allItems.length;
    const totalAmount = allItems.reduce((sum, item) => sum + (item.amountAfterTds || 0), 0);
    const totalSales = allItems.reduce((sum, item) => sum + (item.totalAmountBeforeTds || 0), 0);
    const totalServiceCharges = allItems.reduce((sum, item) => sum + (item.tdsAmount || 0), 0);
    const approvedCount = allItems.filter(item => item.paymentStatus === "SUCCESS").length;
    const pendingCount = allItems.filter(item => item.paymentStatus !== "SUCCESS").length;
    const totalVendors = Object.keys(vendorGroups).length;

    return (
        <div style={styles.container}>
            {/* Header */}
            
            {/* Stats Grid */}
            <div style={styles.statsContainer}>
                <div style={styles.statItem}>
                    <div style={styles.statValue}>{totalVendors}</div>
                    <div style={styles.statLabel}>Total Vendors</div>
                </div>
                <div style={styles.statItem}>
                    <div style={styles.statValue}>{totalSettlements}</div>
                    <div style={styles.statLabel}>Total Settlements</div>
                </div>
                <div style={styles.statItem}>
                    <div style={{...styles.statValue, color: '#28a745'}}>
                        {new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0 }).format(totalAmount)}
                    </div>
                    <div style={styles.statLabel}>To Settle</div>
                </div>
                <div style={styles.statItem}>
                    <div style={{...styles.statValue, color: '#28a745'}}>
                        {approvedCount}
                    </div>
                    <div style={styles.statLabel}>Approved</div>
                </div>
                <div style={styles.statItem}>
                    <div style={{...styles.statValue, color: '#ffc107'}}>
                        {pendingCount}
                    </div>
                    <div style={styles.statLabel}>Pending</div>
                </div>
                <div style={styles.statItem}>
                    <div style={{...styles.statValue, color: '#dc3545'}}>
                        {new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0 }).format(totalServiceCharges)}
                    </div>
                    <div style={styles.statLabel}>Service Charges</div>
                </div>
            </div>

            {/* Date Filter Section */}
            <div style={styles.dateFilterSection}>
                <span style={{fontWeight: '600', fontSize: '13px', color: '#4a5568'}}>📅 Date Range:</span>
                <button
                    style={{
                        ...styles.dateFilterButton,
                        ...(dateFilterType === 'all' ? styles.dateFilterButtonActive : {})
                    }}
                    onClick={() => setDateFilterType('all')}
                >
                    All
                </button>
                <button
                    style={{
                        ...styles.dateFilterButton,
                        ...(dateFilterType === 'today' ? styles.dateFilterButtonActive : {})
                    }}
                    onClick={() => setDateFilterType('today')}
                >
                    Today
                </button>
                <button
                    style={{
                        ...styles.dateFilterButton,
                        ...(dateFilterType === 'week' ? styles.dateFilterButtonActive : {})
                    }}
                    onClick={() => setDateFilterType('week')}
                >
                    This Week
                </button>
                <button
                    style={{
                        ...styles.dateFilterButton,
                        ...(dateFilterType === 'month' ? styles.dateFilterButtonActive : {})
                    }}
                    onClick={() => setDateFilterType('month')}
                >
                    This Month
                </button>
                <button
                    style={{
                        ...styles.dateFilterButton,
                        ...(dateFilterType === 'custom' ? styles.dateFilterButtonActive : {})
                    }}
                    onClick={() => setDateFilterType('custom')}
                >
                    Custom
                </button>
                {dateFilterType === 'custom' && (
                    <>
                        <span style={styles.dateFilterDivider}>|</span>
                        <input
                            type="date"
                            value={customStartDate}
                            onChange={(e) => setCustomStartDate(e.target.value)}
                            style={styles.dateInput}
                            placeholder="Start Date"
                        />
                        <span style={{color: '#718096'}}>to</span>
                        <input
                            type="date"
                            value={customEndDate}
                            onChange={(e) => setCustomEndDate(e.target.value)}
                            style={styles.dateInput}
                            placeholder="End Date"
                        />
                    </>
                )}
                
                <span style={styles.dateFilterDivider}>|</span>
                <input
                    type="date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    style={styles.dateInput}
                    placeholder="From"
                />
                <span style={{color: '#718096'}}>to</span>
                <input
                    type="date"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    style={styles.dateInput}
                    placeholder="To"
                />
                <button
                    onClick={handleSend}
                    style={{ ...styles.button, ...styles.buttonSend }}
                >
                    <Icons.Send /> Generate
                </button>
            </div>

            {/* Filters */}
            <div style={styles.filtersContainer}>
                <div style={styles.searchGroup}>
                    <div style={{ position: 'relative', flex: 1 }}>
                        <input
                            type="text"
                            placeholder={getPlaceholderText()}
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            style={{
                                ...styles.searchInput,
                                borderColor: searchQuery ? '#e66d33' : '#e2e8f0'
                            }}
                            onFocus={(e) => {
                                e.target.style.borderColor = '#e66d33';
                                e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
                            }}
                            onBlur={(e) => {
                                e.target.style.borderColor = '#e2e8f0';
                                e.target.style.boxShadow = 'none';
                            }}
                        />
                    </div>
                </div>

                <select
                    value={searchType}
                    onChange={(e) => setSearchType(e.target.value)}
                    style={styles.selectInput}
                >
                    {searchOptions.map(option => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>

                <select
                    value={selectedStatusFilter}
                    onChange={(e) => setSelectedStatusFilter(e.target.value)}
                    style={{ ...styles.selectInput, minWidth: '130px' }}
                >
                    {statusOptions.map(option => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>

                <button onClick={clearAllFilters} style={{ ...styles.button, ...styles.buttonSecondary }}>
                    <Icons.Clear /> Clear
                </button>

                <button onClick={fetchSettlements} style={{ ...styles.button, ...styles.buttonPrimary }}>
                    <Icons.Refresh /> Refresh
                </button>
                <button onClick={handleExport} style={{ ...styles.button, ...styles.buttonExport }}>
                    <Icons.Export /> Export All
                </button>
            </div>

            {/* Vendor Dashboard Cards */}
            {Object.keys(filteredVendorGroups).length > 0 ? (
                <div style={styles.vendorDashboardGrid}>
                    {Object.entries(filteredVendorGroups).map(([vendorId, vendorData]) => (
                        <VendorDashboardCard
                            key={vendorId}
                            vendorId={vendorId}
                            vendorData={vendorData}
                            onApprove={handleApprove}
                            onUpdateStatus={fetchSettlements}
                        />
                    ))}
                </div>
            ) : (
                <div style={styles.emptyState}>
                    <Icons.NoData />
                    <div style={styles.emptyStateText}>
                        {settlements.length === 0 ? 'Loading settlements...' : 'No vendors found'}
                    </div>
                    <div style={styles.emptyStateSubtext}>
                        {settlements.length === 0
                            ? 'Please wait while we fetch the data'
                            : (searchQuery.trim() || selectedStatusFilter || dateFilterType !== 'all')
                                ? 'Try adjusting your filters to see more results'
                                : 'No catering settlements are available'}
                    </div>
                </div>
            )}

            <style>{`
                @keyframes settlementSlideUp {
                    from { opacity: 0; transform: translateY(30px) scale(0.95); }
                    to { opacity: 1; transform: translateY(0) scale(1); }
                }

                @keyframes settlementFadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }

                @keyframes slideDown {
                    from {
                        opacity: 0;
                        transform: translateY(-10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                .settlement-wrapper {
                    animation: settlementFadeIn 0.4s ease;
                }

                .vendor-card-header:hover {
                    filter: brightness(1.05);
                }

                .kpi-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
                }

                ::-webkit-scrollbar {
                    width: 8px;
                    height: 8px;
                }
                ::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 4px;
                }
                ::-webkit-scrollbar-thumb {
                    background: linear-gradient(135deg, #e66d33 0%, #d45a2a 100%);
                    border-radius: 4px;
                }
                ::-webkit-scrollbar-thumb:hover {
                    background: linear-gradient(135deg, #d45a2a 0%, #b84a1a 100%);
                }

                /* Mobile Responsive */
                @media (max-width: 1024px) {
                    .settlement-container {
                        max-width: 95% !important;
                        padding: 10px !important;
                    }
                    .kpi-grid {
                        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)) !important;
                    }
                    .vendor-details-grid {
                        grid-template-columns: 1fr !important;
                    }
                }

                @media (max-width: 768px) {
                    .settlement-container {
                        max-width: 100% !important;
                        padding: 8px !important;
                    }
                    .filters-container {
                        flex-direction: column !important;
                        align-items: stretch !important;
                    }
                    .search-group {
                        min-width: unset !important;
                        flex-direction: column !important;
                    }
                    .stats-container {
                        grid-template-columns: repeat(3, 1fr) !important;
                        gap: 8px !important;
                        padding: 12px !important;
                    }
                    .stat-value {
                        font-size: 18px !important;
                    }
                    .stat-label {
                        font-size: 10px !important;
                    }
                    .vendor-card-header {
                        padding: 12px 16px !important;
                    }
                    .vendor-header-name {
                        font-size: 15px !important;
                    }
                    .vendor-dashboard-body {
                        padding: 12px !important;
                    }
                    .kpi-grid {
                        grid-template-columns: repeat(2, 1fr) !important;
                        gap: 8px !important;
                    }
                    .kpi-value {
                        font-size: 18px !important;
                    }
                    .vendor-details-grid {
                        grid-template-columns: 1fr !important;
                    }
                    .date-filter-section {
                        flex-wrap: wrap !important;
                        gap: 6px !important;
                        padding: 10px !important;
                    }
                    .date-filter-button {
                        font-size: 10px !important;
                        padding: 4px 10px !important;
                    }
                    .vendor-settlement-table {
                        font-size: 10px !important;
                    }
                    .vendor-settlement-cell {
                        padding: 4px 6px !important;
                        font-size: 10px !important;
                    }
                    .vendor-settlement-header {
                        font-size: 8px !important;
                        padding: 4px 6px !important;
                    }
                    .badge {
                        font-size: 8px !important;
                        padding: 2px 6px !important;
                    }
                }

                @media (max-width: 480px) {
                    .settlement-container {
                        padding: 4px !important;
                    }
                    .stats-container {
                        grid-template-columns: repeat(2, 1fr) !important;
                    }
                    .kpi-grid {
                        grid-template-columns: 1fr 1fr !important;
                    }
                    .header {
                        flex-direction: column !important;
                        align-items: flex-start !important;
                    }
                    .vendor-header-right {
                        width: 100% !important;
                        justify-content: flex-start !important;
                    }
                    .vendor-header-stat {
                        font-size: 10px !important;
                        padding: 2px 8px !important;
                    }
                    .vendor-avatar {
                        width: 36px !important;
                        height: 36px !important;
                        font-size: 18px !important;
                    }
                    .date-filter-section input {
                        min-width: 80px !important;
                        font-size: 11px !important;
                        padding: 4px 8px !important;
                        height: 32px !important;
                    }
                    .date-filter-section span {
                        font-size: 11px !important;
                    }
                }
            `}</style>
        </div>
    );
};

export default CateringSettelment;